import type { ThemeColors } from '@sravni/cosago-react-library/lib/types';

import { PARTNERS_IDS } from 'constants/partners';

const getThemeColors = (color1: string, color2: string): ThemeColors => ({
  color1,
  color2,
});

/**
 * Здесь задаем дефолтные цвета для партнера, которые они потом могут сами переопределить
 *где:
 *  CCS переменная --color-Main100 = color1 (цвет машинки, кнопок и тд)
 *  CCS переменная --color-Main06 = color2 (цвет фона)
 */
export const defaultPartnerThemePalette: Record<number, ThemeColors> = {
  [PARTNERS_IDS.otp]: getThemeColors('34,34,34', '239,242,249'),
  [PARTNERS_IDS.avito]: getThemeColors('76,167,248', '245,247,249'),
};

export const DEFAULT_THEME = getThemeColors('0,42,58', '246,245,244');
